import { configureStore } from "@reduxjs/toolkit";

// importing slices
import userSlice from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
  },
});
